import api from './api';

export const mailTemplatesService = {
  list: (params?: Record<string, any>) =>
    api.get('/mail-templates', { params }).then((r) => r.data),
  getById: (id: number) => api.get(`/mail-templates/${id}`).then((r) => r.data),
  create: (data: any) => api.post('/mail-templates', data).then((r) => r.data),
  update: (id: number, data: any) => api.put(`/mail-templates/${id}`, data).then((r) => r.data),
  delete: (id: number) => api.delete(`/mail-templates/${id}`).then((r) => r.data),
  preview: (id: number) => api.post(`/mail-templates/${id}/preview`).then((r) => r.data),
  duplicate: (id: number) => api.post(`/mail-templates/${id}/duplicate`).then((r) => r.data),
};
